// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export class TraduccionCmpSecondaryTabCmpTiempoAlmacena extends TraduccionLiteral {
    /* STATIC */
    protected static override readonly ID: string = "cmp.secondary_tab.cmp_tiempo_almacena";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpSecondaryTabCmpTiempoAlmacena {
        this.VALUES ??= this.completar({
            "valor": {
                "da": "Maksimal opbevaringstid: {{n}} sekunder",
                "de": "Maximal Speicherdauer: {{n}} Sekunden",
                "en": "Maximum storage time: {{n}} seconds",
                "fr": "Durée de stockage maximale: {{n}} secondes",
                "it": "Tempo massimo di conservazione: {{n}} secondi",
                "nl": "Maximale wachttijd opslag: {{n}} seconden",
                "pt": "Tempo máximo de armazenamento: {{n}} segundos",
                "ru": "Максимальное время хранения: {{n}} секунд"
            },
            "defecto": "Tiempo máximo de almacenamiento: {{n}} segundos"
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
